<template>
  <div class="offer-sales-cross-sell-container" :class="bgAndBorder">
    <div class="offer-sales-cross-sell-content" :class="paddingAndBorder">
      <trigger-target :offer-sale="offerSales[0]" mode="trigger" style="flex: 1" :preview-mode="previewMode" :search="search" />
      <trigger-target :offer-sale="offerSales[0]" mode="target" style="flex: 1" :preview-mode="previewMode" :search="search" />
    </div>
    <div v-if="previewMode" class="see-more" @click="$emit('goToDetails')">
      <span>Ver mais detalhes</span>
    </div>
  </div>
</template>

<script>
import TriggerTarget from './TriggerTarget.vue'

export default {
  components: {
    TriggerTarget,
  },
  props: {
    offerSales: {
      type: Array,
      required: true,
    },
    search: {
      type: String,
      default: '',
    },
    previewMode: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    bgAndBorder() {
      return this.previewMode ? 'bg-cinza-l90 preview-mode-border' : 'bg-white'
    },

    paddingAndBorder() {
      if (this.isMobile) {
        return 'pa-2'
      } else if (this.previewMode) {
        return 'preview-mode-padding preview-mode-border-bottom'
      } else {
        return 'py-8 px-10'
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.offer-sales-cross-sell-container {
  border-radius: 8px;
  border-top-width: 0;
  border-top-left-radius: 0;
  border-top-right-radius: 0;

  .offer-sales-cross-sell-content {
    display: flex;
    flex-direction: row;
    align-items: center;

    @media screen and (max-width: $xs-breakpoint) {
      flex-direction: column;
    }
  }

  .see-more {
    background: #d2e9ff99;
    color: $marca-0-l10;
    height: 54px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;

    &:hover {
      cursor: pointer;
      background-color: #b4dbff99;
    }
  }
}

.preview-mode-border {
  border: 1px solid $cinza-l70;
}

.preview-mode-border-bottom {
  border-bottom: 1px solid $cinza-l70;
}

.preview-mode-padding {
  padding: 42px 52px;
}

.bg-cinza-l90 {
  background: $cinza-l90;
}

.bg-white {
  background: white;
}
</style>
